import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import { useState,useEffect} from "react";
// import axios from "axios";

// Import Local Images
import quality from './imeges/quality.jpg';
import pratice from './imeges/Pratice1.jpeg';
import Lims from './imeges/limis2.jpg';
// import bloodbank from './imeges/bloodbank.jpg';
import bloodbank from './imeges/slide5.2.jpeg';

import integrated from './imeges/intergrated.jpg';
import Healthanaltics from './imeges/Healthanaltics.jpg';
// import ai from './imeges/ai.avif';
// import ai from './imeges/ai1.jpg';
import ai from './imeges/ai2.jpg';

import pharmachy from './imeges/pharmachy.jpg';
// import Tele from './imeges/Tele.avif';
import Tele from './imeges/Tele1.jpg';


// Product Portfolio Data
const products = [
  { id: '1', name:"Lims", title: "LIMS", image: Lims, desc: "Automate your lab operations, Deliver Accurate Reports to Patient every time and Scale up your operations easily.  BBTLabs solution  gives Flexibility for Operational tasks and Complete Control over Clinical and Financial Data." },
  { id: '7', name:"ai",  title: "AI Based Digital Agents", image: ai, desc: "Digital Agents analyze patient history, predict prognosis, and recommend treatment protocols. Doctors can adjust protocols, and the system learns for future use. It also communicates with patients' next of kin for better care." },
  { id: '4', name:"intergrated",  title: "Blood Bank & Integrated Inventory", image: integrated, desc: "Integrated inventory is a system that combines inventory management with other business processes, such as sales, procurement, and logistics, ensuring real-time tracking and seamless data flow across departments." },
  { id: '5', name:"pratice", title: "Practice Management System", image: pratice, desc: "Pratice streamlines scheduling, doctor availability, and administrative tasks, while AI suggests diagnostic tests for better treatment. It also enables nurses to capture patient complaints and integrates inventory for improved healthcare outcomes." },
  { id: '3', name:"bloodbank",  title: "Hospital Information System", image: bloodbank, desc: "A blood bank is a facility that collects, stores, and distributes blood and its components for medical use, ensuring a safe supply for transfusions." },
  { id: '2', name:"quality", title: "Quality Control", image: quality, desc: "Robust Process to capture Quality Data & calculate Laboratory Mean.  Intuitive LJ Graphs gives parameter wise performance and Optional Implementation of Westgard Rules ensures patient reports are reliable and predictable." },
  { id: '6', name:"Healthanaltics",  title: "Health Analytics", image: Healthanaltics, desc: "Extract data from any system (LIS, HIS) using ETL tools, visualize it in Power BI, and make data-driven decisions. Secure connectivity and data cleansing ensure a single source of truth for better insights and efficiency." },
  // { id: '7', name:"ai",  title: "AI Based Digital Agents", image: ai, desc: "Digital Agents analyze patient history, predict prognosis, and recommend treatment protocols. Doctors can adjust protocols, and the system learns for future use. It also communicates with patients' next of kin for better care." },
  { id: '8', name:"pharmachy",  title: "Pharmacy Solutions", image: pharmachy, desc: "Honour Doctor's Prescriptions, Get Accurate Information on Stock availability across branches, Automate regular tasks like Purchase Order Creation and Approval and plan your inventory & control costs. " },
  { id: '9',name:"Tele", title: "Secure Tele Consultations", image: Tele, desc: "Secure teleconsultations are virtual healthcare services that ensure patient-provider communication is confidential, protected by encryption, and compliant with privacy regulations like HIPAA.." },
];

// useEffect(()=>{

// })

const ProductPortfolio = () => {
  const navigate = useNavigate();
  // const [images, setImages] = useState([]); // Store images



  // useEffect(() => {
  //   const fetchImages = async () => {
  //     try {
  //       const response = await axios.get("http://localhost:5000/api/img/images/product"); // Fetch from backend
  //       setImages(response.data);
  //     } catch (error) {
  //       console.error("Error fetching images:", error);
  //     } 
  //   };

  //   fetchImages();
  // }, []);

  // // 🔥 Fetch specific images by name
  // const getImageUrl = (imageName,locaIamge) => {
  //   if (!images || images.length === 0) return locaIamge; // Return placeholder if not found
  //   const image = images.find((img) => img.original_name === imageName);
  //   return image ? image.url : locaIamge; // Default placeholder image
  // };

  // if (error) return <p>{error}</p>;
  return (
    <div className="py-2 px-4 px-md-5" id="services">
      <Container fluid>
        <h2 className="text-center fw-bold mb-4">Product Portfolio</h2>
        <Row className="gy-4 gx-5 justify-content-center">
          {products.map((product) => (
            <Col key={product.id} xs={12} sm={6} md={4} lg={4}>
              <Card className="product-card border-0 shadow rounded-4 h-100 " style={{cursor:'pointer'}} onClick={() => ["1","2","3"].includes(String(product.id)) ?navigate(`/${product.title}`) :  navigate(`/product/${product.id}`,{ state: { product } })}>
                <div className="image-container">
                  <Card.Img variant="top"
                  //  src={getImageUrl(product.name, product.image)} 
                  src={product.image}
                    loading='lazy'className="product-image rounded-top-4" style={{height:'250px'}}/>
                </div>
                <Card.Body className="d-flex flex-column justify-content-center">
                  <h6 className="text-uppercase fw-bold text-center" style={{ color: '#001351' }}>{product.title}</h6>
                  <p className="text-black  text-justify">{product.desc}</p>
                  {/* <Button className=" text-white align-items-center" style={{ backgroundColor: '#001351' ,width:'40%',marginLeft:'30%'}} 
                  onClick={() => navigate(`/product/${product.id}`, { state: { product } })}>
                    Learn More
                  </Button> */}
                  {/* <button  style={{width:'30%',marginLeft:'30%',backgroundColor:'#001351', color:'white'}}>Learn More</button> */}
                  {/* <p className="fw-bold  "  style={{width:'40%',marginLeft:'30%',cursor:'pointer',color:'#001351'}} onClick={() => navigate(`/product/${product.id}`, { state: { product } })}>Learn More</p> */}
                 <div className=" d-flex justify-content-center mt-auto">
                  <p className="fw-bold"  style={{width:'40%',color:'#001351'}}  >Learn More</p>
                 </div>
                  
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Custom CSS */}
      <style>
        {`
          .product-card {
            height: 100%; /* Ensures all cards are equal height */
            display: flex;
            flex-direction: column;
          }

          .image-container {
            height: 200px; /* Ensures uniform image size */
            overflow: hidden;
            border-radius: 12px 12px 0 0;
          }

          .product-image {
            width: 100%;
            height: 100%;
            object-fit: cover; /* Keeps image aspect ratio */
          }

          .card-body {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
            .text-justify {
  text-align: justify;
}

        `}
      </style>
    </div>
  );
};

export default ProductPortfolio;
